import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'webshopOrders',
    path: '/webshop-orders',
    component: () => import('../pages/WebshopPage.vue'),
    props: true,
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: 'webshopAvailableOrderListTab',
        path: '',
        component: () => import('../pages/WebshopAvailableOrderListPage.vue'),
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'WebshopOrderListTab',
        path: '',
        component: () => import('../pages/WebshopOrderListPage.vue'),
        props: true,
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'WebshopOfferDetailsTab',
        path: '',
        component: () => import('../pages/WebshopOfferDetailsPage.vue'),
        props: true,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },
  {
    name: 'WebshopOrderDetails',
    path: '/webshop-orders/:productGroupId',
    component: () => import('../pages/WebshopOrderDetailsPage.vue'),
    props: true,
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
